import React from 'react';

import scss from './MessageCard.module.scss';

const EmptyMessageCard = () => {
  return <div className={scss.emptyMessage} />;
};

export default EmptyMessageCard;
